import Accordion from "./Accordion";
import AccordionItem from "./AccordionItem";

export default function AccordionWithData({ list = [], removeStyle=false }) {
    const uniqueId = `accordion-${Math.floor(Math.random() * 9999)}`;
    return (
        <Accordion removeStyle={removeStyle} uniqueId={uniqueId}>
            {list.map((data, index) => (
                <AccordionItem key={index} uniqueId={index} defaultShow={data?.active} parentAccordionId={uniqueId} title={data?.title}>
                    {data?.content && data.content()}
                </AccordionItem>
            ))}
        </Accordion>
    )
}